import type {MouseEventHandler, ReactElement} from 'react';
import React from 'react';
import {Text} from '@Components/text';
import {PublishingListItemThumbnail} from '@Panels/poster-publishing-options-panel/components/publishing-list-item-thumbnail/publishing-list-item-thumbnail';
import {PublishingOptionsButtons} from '@Panels/poster-publishing-options-panel/components/publishing-options-buttons/publishing-options-buttons';
import ClickableDiv from '@Components/clickable-div/clickable-div';
import {noop} from '@Utils/general.util';
import type {PublishingOptionListItemProps} from './publishing-option-list-item.types';
import styles from './publishing-option-list-item.module.scss';

export function PublishingOptionListItem({
  className,
  heading,
  afterHeadingTextContent = undefined,subheading,
  customThumbnailClasses = '',
  iconName,
  thumbNailType,
  imgSrc,
  showTwoButtons,
  onClick,
  isClicked,
  price,
  headingTextClass = '',
  subheadingTextClass = '',
  iconType,
  flatIconType,
  iconSize,
  iconClasses = '',
  headingContainerClass = '',
}: PublishingOptionListItemProps): ReactElement<any> {
  return (
    <ClickableDiv
      onClick={onClick ?? noop}
      className={`_cursor-pointer flexbox align-items-center color-standard-text radius-12 spacing-p-1 spacing-p-r-4 ${className} ${isClicked ? styles.clickedStyleBg : styles.setHoveredStyle} hover-transition-all`}
    >
      <div className="flexbox align-items-center flex-1 ">
        <PublishingListItemThumbnail
          iconType={iconType ?? undefined}
          flatIconType={flatIconType ?? undefined}
          iconName={iconName}
          thumbNailType={thumbNailType}
          customThumbnailClasses={`${customThumbnailClasses} ${isClicked ? 'border-s-dark' : styles.setBorder} hover-transition-all`}
          imgSrc={imgSrc}
          iconSize={iconSize}
          iconClasses={iconClasses}
        />
        <div className={`flexbox flex-v-row spacing-p-l-3 flex-1 ${isClicked ? 'content-primary' : ''} ${headingContainerClass}`}>
          <div className="flex-row-align-center">
            <Text val={heading} className={`content-body body-xs-bold ${isClicked ? 'content-primary' : ''} ${headingTextClass}`} />
            {afterHeadingTextContent}
          </div>
          <Text val={price ?? ''} className="body-xs-bold content-primary" />
          {subheading ? <Text val={subheading} className={`body-xxs content-disabled-dark capitalize-sentence ${subheadingTextClass}`} /> : null}
        </div>
      </div>
      {showTwoButtons ? <PublishingOptionsButtons /> : null}
    </ClickableDiv>
  );
}
